import React from 'react';
import { observer } from 'mobx-react-lite';
import { Autocomplete, ButtonMenu, Button, Icon, Typography } from '@ann/web-components';
import { DocumentsToShareContainer, DocumentsToShareItem, AutocompleteContainer } from '../Modal.styled';

const ShareModalContent = observer(({
    itemsToShare,
    selectedUsers,
    selectedPermission,
    currentSelectionType,
    privileges,
    onUsersChange,
    onPermissionChange,
    onAddClick,
    usersList
}) => {

    return (
        <>
            <DocumentsToShareContainer>
                {itemsToShare.map((item, index) => (
                    <DocumentsToShareItem key={index}>
                        <Icon name={item.type === 'folder' ? 'folder' : 'description'} size="small" />
                        <Typography
                            category="body"
                            size="medium"
                            weight="regular"
                            color="body"
                            maxCharacters={30}
                        >
                            {item.name}
                        </Typography>
                    </DocumentsToShareItem>
                ))}
            </DocumentsToShareContainer>
            <AutocompleteContainer>
                <Autocomplete
                    multiple={true}
                    maxTagsMode="dynamic"
                    onSelectionChange={onUsersChange}
                    onSearch={() => { }}
                    onSuggestionSelect={() => { }}
                    placeholder="Search team members..."
                    selectedValues={selectedUsers}
                    showInitialName
                    suggestions={usersList}
                    valueKey="user_uuid"
                    labelKey="full_name"
                />
                <ButtonMenu
                    iconPosition="right"
                    label={selectedPermission || 'Edit'}
                    menuPosition="bottom"
                    onChange={onPermissionChange}
                    size="medium"
                    
                    type="secondary"
                    width="auto"
                >
                    <ButtonMenu.Menu>
                        {privileges[currentSelectionType === 'folder' ? 'folderPrivileges' : 'documentPrivileges'].map((privilege) => (
                            <ButtonMenu.Item
                                key={privilege.entityPrivilegeUuid}
                                label={privilege.privilegeName}
                                value={privilege.privilegeName}
                            >
                                {privilege.privilegeName}
                            </ButtonMenu.Item>
                        )) || []}
                    </ButtonMenu.Menu>
                </ButtonMenu>
                <Button
                    label="Add"
                    size="medium"
                    onClick={onAddClick}
                    disabled={selectedUsers.length === 0 || selectedPermission === ''}
                />
            </AutocompleteContainer>
        </>
    );
});

export default ShareModalContent;
